module.exports = __webpack_public_path__ + "img/logos.fe2daa34.png";